module.exports = __webpack_public_path__ + "media/images/episode-comments-thanks-title-b7c801abe248b9bd283f52bde8c3be88.png";